module.exports = __webpack_public_path__ + "img/spartan-demolition-sitework-04-xxlarge.80009fbe.jpg";